import styled from 'styled-components';

export const Button = styled.div`
  cursor: pointer;
  font-size: 14px;
  line-height: 30px;
  margin: 0;
  outline: 0;
  overflow: hidden;
  text-align: center;
  border-radius: 10px;
`;